//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CreditCardMetaData } from './CreditCardMetaData';
import { PaymentMethod } from './Enums';

export class OnlinePaymentSettingsDisplayItem extends ItemBase {
    CreditCardsMetaData: CreditCardMetaData[] = [];
    OnlinePaymentMethods: PaymentMethod[] = [];

    constructor(initializer?: Partial<OnlinePaymentSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OnlinePaymentSettingsDisplayItem";
}
